import data from "../../../../../src/AvatarStack/AvatarStack.docs.json";
import { AvatarStack } from '@primer/react';
import * as React from 'react';
export default {
  data,
  AvatarStack,
  React
};